import { FormControlLabel, Switch } from '@mui/material';
import { useSelector } from 'react-redux';
import { _ } from '/@/locale';
import { updateFieldFromAPI } from '/@/store/fields/apiProviders';
import { getEnabledFrostRisk, getSessionCountry } from '/@/store/session/selectors';

/** @param {{field: {id: string}}} props */
export default function FieldFrostRiskNotificationToggle({ field }) {
    const enabled = useSelector(getEnabledFrostRisk);
    const country = useSelector(getSessionCountry);

    if (!enabled) return null;
    return (
        <div
            onClick={(e) => {
                e.stopPropagation();
            }}
        >
            <FormControlLabel
                componentsProps={{ typography: { sx: { fontSize: '1.3rem' } } }}
                control={
                    <Switch
                        size='small'
                        disabled={!field}
                        onChange={(e) => {
                            updateFieldFromAPI({
                                fieldId: field.id,
                                country: country.code,
                                name: field.name,
                                enableFrostRiskNotification: e.target.checked,
                            });
                        }}
                        checked={field.enableFrostRiskNotification}
                        name='enableFrostRiskNotification'
                    />
                }
                size='small'
                label={_('Recibir notificaciones de riesgo de helada')}
            />
        </div>
    );
}
